import React from "react";
import TextInput from './TextInput';
import FixButton from './Button';
import AddRata from "./AddRataWidget";
import RataStatusWidget from "./RataStatusWidget";
import moment from 'moment';
import Cookies from 'universal-cookie';
import getRataStatus from "../services/getRataStatus";
import translateString from "../utils/Locales";
import Utils from "../utils/utils";
import getClient from "../services/getClient";

let t = translateString;

export default class GestioneRateWidget extends React.Component {

    constructor(props){
        super(props)

        this.state = {
            costo: 0,
            showAddRata: false,
            custom: this.props.custom,
            piano: this.props.piano, 
            isLoading: true,
        }
    }

    async reload(){
        if (!this.props.isStudent) return;

        this.setState({ isLoading: true });
        const studentId = this.props.studentObj.id;
        const corsoId = this.props.corso.id;

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        this.rataStatus = await getRataStatus(username, token, corsoId, studentId);
        this.cliente = await getClient('', '', cookies.get('db', { path: '/' }));

        this.setState({ isLoading: false, cliente: this.cliente });
    }

    aggiungiRata(){
        this.setState({showAddRata: true});
        this.props.onOpen();
    }

    async componentDidMount(){
        await this.reload();
    }

    salva() {
        
        if (this.state.piano === undefined) {
            Utils.showInfo(t('inserire_costo'))
            return;
        }

        var costo = parseFloat(this.state.piano.costo.replace(/,/g, '.'));
        if (this.state.piano.costo.replace(/,/g, '.').includes('.')) {
            Utils.showError(t('errore_costo_int'));
            return;
        }
        if (isNaN(costo)) {
            Utils.showError(t('errore_costo'));
            return;
        }

        var datesList = [];
        if (this.state.piano.rate)
            for (var r of this.state.piano.rate){
                if (datesList.indexOf(r.data) == -1)
                    datesList.push(r.data);
                else {
                    alert (t('rate_p_giorno'));
                    return;
                }
            }

        var importoTot = 0;
        if (this.state.piano.rate)
            for (var r of this.state.piano.rate){
                console.log(r.importo);
                importoTot += parseFloat(r.importo);
            }

        if (importoTot != costo){
            alert (t('totale_u_costo'));
            return;
        }

        var error = false;
        for (var i = 1; i < this.state.piano.rate.length; i++){
            const r1 = this.state.piano.rate[i - 1];
            const r2 = this.state.piano.rate[i];
            if (r1.data == r2.data) error = true;
        }

        if (error == true){
            alert (t('rate_p_giorno'));
            return;
        }
        this.props.onSalva(this.state.piano.costo, this.state.piano.rate ? this.state.piano.rate : [], this.rataStatus);
    }



    render() {

        var detailString = undefined;
        if (this.state.piano != undefined && this.state.piano.rate != undefined) {

            var importoPagato = 0;
            var importoDaPagare = 0;
            for (var rata of this.state.piano.rate){
                var rataDetails = this.rataStatus == undefined ? undefined : this.rataStatus.find(r => r.data == rata.data && r.importo == rata.importo);
                var status = rataDetails != undefined ? rataDetails.status : 'NON PAGATA';
                var importo = rata.importo;

                if (status == 'PAGATA')
                    importoPagato += parseInt(importo);
                else
                    importoDaPagare += parseInt(importo);
            }

            detailString = t('pagato') + importoPagato + t('da_pagare') + importoDaPagare;
        }

        
        return (
        <div style={mainWidgetDiv}>
        <div style={{ marginLeft: 5 }}>{detailString}</div>

        { this.props.compactMode != true && <TextInput name={t('costo_stud')} value={this.state.piano != undefined ? this.state.piano.costo : 0} 
                onChange={(text) => {
                    this.setState(prevState => ({
                        piano: {
                            ...prevState.piano,
                            costo: text
                        }
                    })
                    )}}
        /> }
        <br/>
        { this.props.compactMode != true && <FixButton title={t('aggiungi_rata')} callback={this.aggiungiRata.bind(this)} /> }

        {

            this.state.piano && this.state.piano.rate && this.state.piano.rate.map((rata, index) => {

                var rataDetails = this.rataStatus == undefined ? undefined : this.rataStatus.find(r => r.data == rata.data && r.importo == rata.importo);
                var status = rataDetails != undefined ? rataDetails.status : 'NON PAGATA';
                let foundRata = (this.rataStatus && this.rataStatus.length > 0) ? this.rataStatus.find((r) => parseInt(r.importo) === parseInt(rata.importo) && rata.data === r.data) : undefined
                let id_get = foundRata ? foundRata.id : undefined;

                return (<div key={Math.random()} style={{ display: 'flex', marginTop: index === 0 ? 20 : 0, marginBottom: index == this.state.piano.rate.length - 1 ? 20 : 0 }}>
                    <div style={rataDiv} onClick={async () => {
                        if (this.props.compactMode) return;
                        this.props.onOpen();
                        this.setState({
                            rataStatusWidgetVisible: true,
                            status: status,
                            rataIndex: index,
                            rata: {
                                id: id_get,
                                rCompleta: foundRata, 
                                studente: this.props.studentObj,
                                data: rata.data,
                                importo: rata.importo,
                                corso: this.props.corso,
                                files: rataDetails ? rataDetails.files : undefined,
                                note: rataDetails ? rataDetails.note : undefined
                            }
                            });
                        }}>

                        <div>{t('data')}: {rata.data}</div>
                        <div>{t('importo')}: {rata.importo + '€'}</div>
                        {this.props.isStudent ? <div>{t('stato')}: {status}</div> : null}
                        {rataDetails != undefined && rataDetails.note != undefined && rataDetails.note != '' ? <div>{t('note')}: {rataDetails.note}</div> : null}
                        { (this.state.cliente && this.state.cliente.fatturazione_attiva === '1' && foundRata) && <p style={{ fontSize: 12, color: foundRata.inviata_sdi === '1' ? 'green' : 'red' }}>{foundRata.inviata_sdi === '1' ? t('fatt_inviata') : t('fatt_n_inviata')}</p> }
                        { (this.state.cliente && this.state.cliente.fatturazione_attiva === '1' && !foundRata) && <p style={{ fontSize: 12, color: 'red' }}>{t('fatt_n_inviata')}</p> }
                    </div>

                    { this.props.compactMode != true && (
                        <div style={{color: '#ff0000', cursor: 'pointer', width: '100px', textAlign: 'center' }}
                        onClick={() => {
                            if (window.confirm(t('elimina_rata')) == false) return;
                            if (status == 'PAGATA'){
                                Utils.showError(t('rata_g_pagata'));
                                return;
                            }
                            var piano = this.state.piano;
                            piano.rate.splice(index, 1);
                            this.setState({piano: piano});
                        }}>
                            <img alt="" src={ require('../images/delete.png') } style={{ height: 20, width: 20, marginTop: (this.state.cliente && this.state.cliente.fatturazione_attiva === '1') ? 48 : 30 }} title={t('elimina_rata_2')} />
                        </div> 
                    )}
                </div>);
            })
        }

        { this.props.compactMode != true && <FixButton title={t('aggiorna_rate')} callback={this.salva.bind(this)} /> }

        <RataStatusWidget show={this.state.rataStatusWidgetVisible} 
        rata={this.state.rata} 
        status={this.state.status} 
        isStudent={this.props.isStudent}
            onClose={(rata) => {
                this.setState({rataStatusWidgetVisible: false});
                this.props.onOpen();
                if (rata == undefined) return;

                var newRata = {
                    data: rata.data,
                    importo: rata.importo
                };
                var piano = this.state.piano;
                var oldData = piano.rate[this.state.rataIndex].data;
                var oldImporto = piano.rate[this.state.rataIndex].importo;
                piano.rate[this.state.rataIndex] = newRata;

                var currentRata = null;
                for (var i = 0; i < this.rataStatus.length; i++){
                    var s = this.rataStatus[i];
                    if (s.data != oldData || s.importo != oldImporto) continue;
                    currentRata = s;
                    s.data = rata.data;
                    s.importo = rata.importo;
                    s.status = rata.status;
                    s.files = rata.files;
                    s.note = rata.note;
                    s.data_pagamento = rata.dataPagamento;
                    s.metodo = rata.metodo;
                    s.n_fattura = rata.n_fattura;
                    s.inviata_sdi = rata.inviata_sdi;
                    s.uuid_sdi = rata.uuid_sdi;
                    this.rataStatus[i] = s;
                }

                if (currentRata == null){
                    this.rataStatus.push(rata)
                }

                this.props.onModification();

                this.setState({piano: piano});
            }}
        />

        <AddRata show={this.state.showAddRata} onClose={()=> {this.setState({showAddRata: false}); this.props.onOpen(); }} 
                    isStudent={this.props.isStudent}
                    onFinish={(data, rata, status) => {
                        var rate = [];
                        
                        if (this.state.piano != undefined) rate = this.state.piano.rate
                        if (rate == undefined) rate = [];
                        
                        rate.push({
                            data: data,
                            importo: rata
                        });

                        this.rataStatus && this.rataStatus.push({
                            id_corso: this.props.corso.id,
                            id_studente: this.props.studentObj.id,
                            importo: rata,
                            data: data,
                            note: '',
                            files: '',
                            status: status
                        });

                        rate = rate.sort((l1, l2) => {
                            var ll1 = moment(l1.data, "DD-MM-yyyy");
                            var ll2 = moment(l2.data, "DD-MM-yyyy");
                            return ll1 - ll2;
                          });

                          this.props.onModification && this.props.onModification();

                        this.setState({showAddRata: false});
                        this.props.onOpen();
                        this.setState(prevState => ({
                            piano: {
                                ...prevState.piano,
                                rate: rate
                            }}));
                        }}
                    />
        </div> );
    }
}

const rataDiv = {
    padding: '5px',
    borderRadius: '10px', 
    boxShadow: '0px 2px 10px lightgrey',
    marginBottom: '8px', 
    marginLeft: 5,
    paddingTop: 10, 
    paddingBottom: 10,
    paddingLeft: 20,
    minWidth: 'calc(100% - 100px)', 
    cursor: 'pointer',
    position: 'relative',
    left: 0, 
    top: 0,
}

const mainWidgetDiv = {
    padding: '10px',
    paddingLeft: 20, 
    paddingTop: 20, 
    paddingBottom: 20,
    marginBottom: '20px',
    zIndex: 2000,
    backgroundColor: 'white', 
    borderRadius: '10px', 
    boxShadow: '0px 2px 10px lightgrey',
}